import _ from "lodash";
import React, { Component } from "react";
import { bool, object, string } from "prop-types";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import { Panel } from "common";

const COLORS = ["#619bf9", "#abcafc", "#dce9fe"];

class PieGraph extends Component {
  static propTypes = {
    title: string,
    isLoading: bool,
    errors: string,
    data: object
  };

  render() {
    let data = this.props.data;
    data = _.map(data, (item, index) => ({
      name: index,
      value: item
    }));
    
    const isLoading = this.props.isLoading || _.isEmpty(this.props.data);
    return (
      <Panel
        containerClass="col-md-6 p-3 float-left"
        isLoading={isLoading}
        errors={this.props.errors}
        padding={2}>
        <Panel.Subtitle text={this.props.title} />
        <Panel.Body
          render={() => {
            return (
              <ResponsiveContainer height={230}>
                <PieChart className="device-graph" width={230} height={180}>
                  <Pie
                    labelLine={false}
                    dataKey="value"
                    data={data}
                    cx={115}
                    cy={115}
                    innerRadius={30}
                    outerRadius={60}>
                    {data.map((entry, index) => (
                      <Cell key={index} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            );
          }}
        />
      </Panel>
    );
  }
}

export { PieGraph };



// WEBPACK FOOTER //
// ./src/common/PieGraph.js